import { render, staticRenderFns } from "./CambioPropietario.vue?vue&type=template&id=77b58ebe&"
import script from "./CambioPropietario.vue?vue&type=script&lang=ts&"
export * from "./CambioPropietario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports